// extracted by mini-css-extract-plugin
export var DocsHeading = "styles-module--DocsHeading--1XoR-";
export var leadParagraph = "styles-module--leadParagraph--1m38n";